import React from 'react';
import './Hyperlink.scss';

function Hyperlink({ hyperlinkData }) {
  return (
    <a
      className="hyperLink"
      href={hyperlinkData.href}
      target="_blank"
      rel="sponsored"
      aria-label={hyperlinkData.label}
    >
      {hyperlinkData.copy}
    </a>
  );
}

export default Hyperlink;
